<template>
	<b-dropdown right variant="link" no-caret>
		<template slot="button-content">
			<font-awesome-icon icon="cog"/>
		</template>
		<b-dropdown-item-button @click="edit()">Edit</b-dropdown-item-button>
  	</b-dropdown>
</template>

<script>
	export default {
		props: ['id'],
		methods: {
			edit() {
				this.$router.push({ name: 'bigNumber.edit', params: { bigNumber_id: this.id } });
			}
		}
	}
</script>

<style scoped>
	.btn-link {
		color:#444;
		padding: 0;
	}
	.btn-link:hover {
		color:#444;
	}
</style>